import { render, staticRenderFns } from "./push-archive.vue?vue&type=template&id=952610da&scoped=true&"
import script from "./push-archive.vue?vue&type=script&lang=js&"
export * from "./push-archive.vue?vue&type=script&lang=js&"
import style0 from "./push-archive.vue?vue&type=style&index=0&id=952610da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "952610da",
  null
  
)

export default component.exports